<template>
<div class="role">
  <el-card class="box-card" shadow="never">
    <el-form ref="form" :inline="true" :model="form">
      <el-form-item label="组织" v-show="auth.includes(13)">
        <el-select v-model="form.groupId" placeholder="请选择组织" clearable style="width: 250px;">
          <el-option v-for="(item, index) in groupList" :key="index" :label="item.groupName" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-input clearable v-model="form.searchKey" @keyup.enter.native="searchRolePage" style="width: 230px;" placeholder="请输入关键字 角色"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="searchRolePage">搜索</el-button>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="showAddRoleDiloag" v-show="auth.includes(14)">添加</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="tableData" border height="64vh" style="width: 100%;margin-top: 10px;">
      <el-table-column type="index" label="序号" width="80" align="center"></el-table-column>
      <el-table-column prop="roleName" label="角色名称" width="150">
        <template slot-scope="{ row }">
          <span>{{ row.roleName }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="roleDescribe" label="角色描述"></el-table-column>
      <el-table-column prop="roleType" label="角色类型">
        <template slot-scope="{ row }">
          <span>{{ row.roleType == -1 ? '超级管理员' : '普通管理员' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="创建时间"></el-table-column>
      <el-table-column prop="status" label="状态" width="120">
        <template slot-scope="{ row }">
          <span>{{ row.status == 0 ? '删除' : '正常' }}</span>
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="操作" width="200" align="center">
        <template slot-scope="scope">
          <el-button v-show="auth.includes(15)" @click="deleteRole(scope.row)" type="text" size="small">删除</el-button>
          <el-button v-show="auth.includes(29)" @click="showEditRoleDiloag(scope.row)" type="text" size="small">修改</el-button>
          <el-button v-show="auth.includes(16)" type="text" size="small" @click="showAddRoleRightDiloag(scope.row)">权限分配</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="form.page" :page-sizes="pageList" :page-size="form.size" layout="total, sizes, prev, pager, next, jumper" :total="total" style="text-align: center;margin-top: 20px;"></el-pagination>
  </el-card>
  <!-- 添加角色 -->
  <Dialog ref="dlgAddRole" :title="dlgTitle">
    <el-form ref="roleForm" :model="roleData" label-width="100px" :rules="rules">
      <el-form-item label="角色名称" prop="roleName">
        <el-input v-model="roleData.roleName" style="width: 90%;"></el-input>
      </el-form-item>
      <el-form-item label="角色类型" prop="roleType">
        <el-select v-model="roleData.roleType" clearable placeholder="角色类型" style="width: 70%;">
          <el-option v-for="(item, index) in roleTypeList" :key="index" :label="item.roleType" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="角色描述" prop="roleDescribe">
        <el-input v-model="roleData.roleDescribe" style="width: 90%;"></el-input>
      </el-form-item>
      <el-form-item style="text-align:right" class="btn-tools">
        <el-button class="btn" type="primary" @click="onSaveRole('roleForm')">保存</el-button>
      </el-form-item>
    </el-form>
  </Dialog>
  <!-- 权限分配 -->
  <Dialog ref="dlgAddRoleRight" title="权限分配" dlgWidth="40%">
    <el-form ref="formAddRoleRight" :inline="true" :model="roleRightData">
      <!-- <el-form-item>
        <el-input v-model="roleRightData.resourceName" placeholder="资源名称"></el-input>
      </el-form-item>
      <el-form-item>
        <el-select v-model="roleRightData.resourceType" clearable placeholder="资源类型">
          <el-option v-for="(item, index) in resourceList" :key="index" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item> -->
      <el-form-item>
        <el-input v-model="roleRightData.projectName" placeholder="项目名称" style="width: 300px;margin-left: 10px;"></el-input>
      </el-form-item>
      <el-form-item style="display: block;">
        <el-tree style="height: 50vh;overflow: auto;" :data="roleRightList" show-checkbox node-key="id" ref="tree" highlight-current :props="defaultProps">
          <div class="custom-tree-icon" slot-scope="{ data }">
            <i :class="data.type == 1 ? 'iconfont icon-ziyuanguanli' : data.type == 2 ? 'iconfont icon-sjpz1' : 'iconfont icon-xiangmupeizhi'"></i>
            {{ data.name }}
          </div>
        </el-tree>
      </el-form-item>
      <el-form-item style="width: 100%;text-align: center;">
        <el-button type="primary" @click="addConfigResourceTree">保存权限</el-button>
      </el-form-item>
    </el-form>
  </Dialog>
</div>
</template>

<script>
import ROLEAPI from '@/api/role';
import GROUPAPI from '@/api/group';
import Dialog from '@/components/dialog';
import {
  getInfo
} from '@/utils/auth';
export default {
  components: {
    Dialog
  },
  data() {
    return {
      update: false,
      auth: [],
      dlgTitle: '添加角色',
      roleRightList: [],
      defaultChecked: [],
      defaultProps: {
        children: 'childrenList',
        label: 'name'
      },
      form: {
        size: 10,
        page: 1,
        groupId: '',
        searchKey: '',
        groupId: 1
      },
      rules: {
        roleName: [{
          required: true,
          message: '角色名称不能为空',
          trigger: 'blur'
        }]
      },
      total: 0,
      pageList: [10, 20, 30, 50],
      groupList: [],
      tableData: [],
      roleData: {
        roleName: '',
        roleType: '',
        roleDescribe: ''
      },
      roleTypeList: [{
          id: 0,
          roleType: '普通管理员'
        },
        {
          id: 1,
          roleType: '管理员'
        }
      ],
      roleRightData: {
        // resourceName: '',
        // resourceType: null,
        projectName: ''
      },
      resourceList: [{
          id: 0,
          name: '通用'
        },
        {
          id: 1,
          name: '平台'
        },
        {
          id: 2,
          name: '一级指标'
        },
        {
          id: 3,
          name: '二级指标'
        },
        {
          id: 4,
          name: '菜单'
        },
        {
          id: 5,
          name: '功能块'
        },
        {
          id: 6,
          name: '按钮'
        },
        {
          id: 7,
          name: '项目模块'
        },
        {
          id: 8,
          name: '组织模块'
        }
      ]
    };
  },
  watch: {
    // 'roleRightData.resourceName'(val) {
    //   this.searchUserBindRoles();
    // },
    // 'roleRightData.resourceType'(val) {
    //   this.searchUserBindRoles();
    // },
    'roleRightData.projectName'(val) {
      this.searchUserBindRoles();
    }
  },
  methods: {
    //初始化
    init() {
      this.auth = this.COMM.getActiveAuth();
      this.form.groupId = JSON.parse(getInfo()).groupId;
      this.searchGroup();
      this.searchRolePage();
    },
    //检索角色
    searchRolePage() {
      this.tableData = [];
      let params = this.form;
      ROLEAPI.searchRolePage(params).then(res => {
        this.tableData = res.data.data.content;
        this.total = res.data.data.totalElements;
      });
    },
    //查询角色资源树
    searchUserBindRoles() {
      let params = {
        projectName: this.roleRightData.projectName,
        resourceType: this.roleRightData.resourceType ? this.roleRightData.resourceType : null,
        roleId: this.roleData.id,
        searchKey: this.roleRightData.resourceName
      };
      ROLEAPI.searchRoleResourceTreeV2(params).then(res => {
        let self = this;
        if (res.data.code == 200) {
          self.roleRightList = [];
          self.$nextTick(function () {
            self.roleRightList = [res.data.data];
            self.roleRightList = self.COMM.updateTreeDataV2(self.roleRightList);
            let result = self.COMM.getAllNodeV2(self.roleRightList);
            self.defaultChecked = [];
            let tmpChecked = [];
            result.forEach(item => {
              if (item.checked == 1) {
                //0.未选中 1.全选中 2.半选
                tmpChecked.push(item.id);
              }
            });
            self.defaultChecked = self.unique(tmpChecked);
            self.$refs.tree.getNode(0);
            self.setChecked();
          });
        }
      });
    },
    //设置值
    setChecked() {
      let self = this;
      setTimeout(function () {
        let tmpChecked = self.defaultChecked;
        tmpChecked.forEach(item => {
          self.$refs.tree.setChecked(item, true, true);
        });
      }, 100);
    },
    //去重
    unique(arr) {
      return Array.from(new Set(arr));
    },
    //重置
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    //显示对话框
    showAddRoleDiloag() {
      let self = this;
      if (this.form.groupId) {
        this.$nextTick(function () {
          self.dlgTitle = '添加角色';
          self.roleData = JSON.parse(
            JSON.stringify({
              roleName: '',
              roleDescribe: ''
            })
          );
          self.$refs.dlgAddRole.open();
        });
      } else {
        this.$message.warning('请选择组织');
      }
    },
    //显示对话框
    showEditRoleDiloag(row) {
      if (this.form.groupId) {
        this.dlgTitle = '编辑角色';
        this.roleData = row;
        this.$refs.dlgAddRole.open();
      }
    },
    //显示角色权限对话框
    showAddRoleRightDiloag(row) {
      this.roleData = row;
      this.searchUserBindRoles();
      if (this.form.groupId) {
        this.$refs.dlgAddRoleRight.open();
      } else {
        this.$message.warning('请选择组织');
      }
    },
    //获取组织列表
    searchGroup() {
      GROUPAPI.searchGroup().then(res => {
        this.groupList = res.data.data;
      });
    },
    //删除角色
    deleteRole(row) {
      let self = this;
      this.$confirm('确定要执行此操作?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(() => {
          ROLEAPI.deleteRole({
            dataId: row.id
          }).then(res => {
            this.$message.success('操作成功');
            self.searchRolePage();
          });
        })
        .catch(() => {});
    },
    //修改角色
    updateRole(formName) {
      let params = JSON.parse(JSON.stringify(this.roleData));
      params.groupId = this.form.groupId;
      // params.roleType = 0;
      this.$refs[formName].validate(valid => {
        if (valid) {
          ROLEAPI.updateRole(params).then(res => {
            if (res.data.code == 200) {
              this.$message.success('操作成功');
              this.$refs.dlgAddRole.close();
              this.searchRolePage();
            }
          });
        } else {
          return;
        }
      });
    },
    //添加角色
    addRole(formName) {
      let params = JSON.parse(JSON.stringify(this.roleData));
      params.groupId = this.form.groupId;
      // params.roleType = 0;
      this.$refs[formName].validate(valid => {
        if (valid) {
          ROLEAPI.addRole(params).then(res => {
            if (res.data.code == 200) {
              this.$message.success('操作成功');
              this.$refs.dlgAddRole.close();
              this.searchRolePage();
            }
          });
        } else {
          return;
        }
      });
    },
    //保存提交
    onSaveRole() {
      if (this.roleData.id) {
        this.updateRole('roleForm');
      } else {
        this.addRole('roleForm');
      }
    },
    //设置页数
    handleSizeChange(val) {
      this.form.size = val;
      this.searchRolePage();
    },
    //设置当前页
    handleCurrentChange(val) {
      this.form.page = val;
      this.searchRolePage();
    },
    //保存分配权限树(缺陷-如果是多个项目应用了同一个资源，那么必须把所有的资源id同步才生效，否则有权限，其他项目都有)
    addConfigResourceTree() {
      let checkedNode = this.$refs.tree.getCheckedNodes();
      let halfCheckedNodes = this.$refs.tree.getHalfCheckedNodes();
      let params = {
        roleId: this.roleData.id,
        resourceIds: []
      };
      halfCheckedNodes.forEach(item => {
        if (item.type == 1) {
          let id = parseInt((item.id.split('.'))[0]);
          params.resourceIds.push(id);
        }
      });
      checkedNode.forEach(item => {
        if (item.type == 1) {
          let id = parseInt((item.id.split('.'))[0]);
          params.resourceIds.push(id);
        }
      });
      let resParams = {
        roleId: this.roleData.id,
        resourceIds: this.unique(params.resourceIds)
      };
      ROLEAPI.addRoleResources(resParams).then(res => {
        if (res.data.code == 200) {
          this.$message.success('操作成功');
          this.searchUserBindRoles();
          this.$refs.dlgAddRoleRight.close();
        }
      });
    }
  },
  created() {
    this.init();
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/boss/role/index.vue